import {NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {IonicApp, IonicModule, IonicErrorHandler} from 'ionic-angular';
import {BrowserModule} from '@angular/platform-browser';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClientModule, HttpClient} from '@angular/common/http';
import {AppEngineer} from './app.component';

// import {AngularFireModule} from 'angularfire2';
// import {AngularFireDatabaseModule} from 'angularfire2/database';
// import {AngularFirestoreModule} from 'angularfire2/firestore';
// import {AngularFireAuthModule} from 'angularfire2/auth';
// import {AppSettings} from '../services/app-settings'
import {NotificationService} from '../services/notification-service'

import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {BarcodeScanner} from '@ionic-native/barcode-scanner';
import {Geolocation} from '@ionic-native/geolocation';
import {GoogleAnalytics} from '@ionic-native/google-analytics';
import {IonicStorageModule} from "@ionic/storage";
import {DataService} from "../services/data-service";
import {LaunchNavigator} from "@ionic-native/launch-navigator";
import {DocumentTypePipe} from "../services/document.pipe";
import {ServicePipe} from "../services/service.pipe";
import {Diagnostic} from "@ionic-native/diagnostic";
import {File} from '@ionic-native/file';
import {FilePath} from '@ionic-native/file-path';
import {Camera} from '@ionic-native/camera';
import {ActionService} from "../services/action-service";
import {Transfer} from "@ionic-native/transfer";

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppEngineer
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(AppEngineer),
    IonicStorageModule.forRoot({
      name: 'aims_db',
      storeName: 'branch',
      driverOrder: ['localstorage', 'indexeddb', 'sqlite', 'websql']
    }),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
    // AngularFireModule.initializeApp(AppSettings.FIREBASE_CONFIG),
    // AngularFireDatabaseModule,
    // AngularFireAuthModule,
    // AngularFirestoreModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [AppEngineer],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    Diagnostic,
    Geolocation,
    BarcodeScanner,
    Camera,
    File,
    FilePath,
    Transfer,
    StatusBar,
    SplashScreen,
    NotificationService,
    DataService,
    ActionService,
    DocumentTypePipe,
    ServicePipe,
    LaunchNavigator,
    // GoogleAnalytics,
    {
      provide: ErrorHandler,
      useClass: IonicErrorHandler
    }
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts